import { postData } from '@services/api-service';

export const signOut = () => postData({ requestUrl: 'signOut' });
